import type { AuthActionTypes } from '@/store/actions/authActions';
import {
  CLEAR_AUTH_ERROR,
  GENERATE_OTP_FAILURE,
  GENERATE_OTP_REQUEST,
  GENERATE_OTP_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  RESET_AUTH_STATE,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
} from '@/store/actions/authActions';
import type { AuthState } from '@/types/auth.types';

const initialState: AuthState = {
  isLoading: false,
  isGenerating: false,
  error: null,
  success: false,
  otpGenerated: false,
  mobileNumber: null,
  email: null,
  transactionId: null,
  deliveryMethod: null,
  maskedDestination: null,
  accessToken: null,
  refreshToken: null,
  customerId: typeof window !== 'undefined' ? localStorage.getItem('customerId') : null,
};

const authReducer = (state = initialState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
    case REGISTER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        success: false,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        success: true,
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        success: false,
      };

    case LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        success: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        success: true,
        mobileNumber: action.payload.mobileNumber,
        email: action.payload.email,
        transactionId: action.payload.transactionId,
        deliveryMethod: action.payload.deliveryMethod,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        success: false,
      };

    case GENERATE_OTP_REQUEST:
      return {
        ...state,
        isGenerating: true,
        error: null,
        otpGenerated: false,
      };
    case GENERATE_OTP_SUCCESS:
      return {
        ...state,
        isGenerating: false,
        error: null,
        otpGenerated: true,
        maskedDestination: action.payload.maskedDestination,
        deliveryMethod: action.payload.deliveryMethod,
      };
    case GENERATE_OTP_FAILURE:
      return {
        ...state,
        isGenerating: false,
        error: action.payload,
        otpGenerated: false,
      };

    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        success: false,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        success: true,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        customerId: action.payload.customerId,
      };
    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        success: false,
      };

    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null,
      };
    case RESET_AUTH_STATE:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
